module.exports = ".menu-button {\n  height: 53.61px;\n  width: 50px; }\n\n.content {\n  padding-top: 53.61px; }\n"